(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9393],{

/***/ 4317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manifesto",
      function () {
        return __webpack_require__(5645);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1151);
/* harmony import */ var _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4022);
/* harmony import */ var _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7310);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__);
// import node_modules




// import components


// import styles

// define component
var LocalMarkdown = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default().markdown),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_5__/* .MDXProvider */ .Zo, {
            components: {
                StorylinerImage: _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                a: _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
            },
            children: children
        })
    });
};
LocalMarkdown.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LocalMarkdown);


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4090);
// import node_modules



// import components

// define components
var MarkdownImage = function(param) {
    var height = param.height, hasShadow = param.hasShadow, imageId = param.imageId, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "storyliner-markdown-image",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
            hasShadow: hasShadow,
            height: height,
            imageId: imageId,
            title: title,
            width: width
        })
    });
};
MarkdownImage.defaultProps = {
    hasShadow: false
};
MarkdownImage.propTypes = {
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownImage);


/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5676);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import types

// define component
var MarkdownLink = function(param) {
    var children = param.children, href = param.href;
    // storyliner link
    if (href === null || href === void 0 ? void 0 : href.includes("https://storylinerlabs.com")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            className: (_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
            href: href.replace("https://storylinerlabs.com", ""),
            passHref: true,
            children: children
        });
    }
    // external link
    if ((href === null || href === void 0 ? void 0 : href.includes("http")) || (href === null || href === void 0 ? void 0 : href.includes("mailto"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    });
};
MarkdownLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownLink);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 5645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1151);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4468);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3192);
/* harmony import */ var _components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8325);
/* harmony import */ var _components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6880);
/* harmony import */ var _components_meta_SEO__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8897);
/* harmony import */ var _components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9748);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8362);
/*@jsxRuntime automatic @jsxImportSource react*/ /*import node_modules*/ /*import types*/ /*import components*/ /*import config*/ /*define layout*/ /*Navbar*/ /*define content*/ 










var MDXLayout = function(param) {
    var children = param.children;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_SEO__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    description: "That's why we've created a new and original way of creating content. Our motivations for the Storyliner Philosophy are set out in the manifesto. Read now …",
                    hrefLang: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_MANIFESTO_DE */ .gv.WEBSITE_MANIFESTO_DE,
                    image: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .storylinerRootDomain */ .pk, "/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg"),
                    title: "Manifesto - The Storyliner Philosophy - Storyliner"
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    children: [
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                            height: "64px"
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                            height: "50px"
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        cols: "prose",
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: children
                        })
                    })
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "50px"
                    })
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    bgColor: "desertStorm",
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "100px"
                    })
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    bgColor: "desertStorm"
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    bgColor: "desertStorm",
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "100px"
                    })
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "50px"
                    })
                })
            ]
        })
    });
};
function _createMdxContent(props) {
    var _components = Object.assign({
        p: "p",
        em: "em",
        h2: "h2",
        h3: "h3"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                tag: "label",
                children: "Manifesto"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                tag: "h1",
                children: "Great communication starts with a storyline."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Creative thinking is what makes us unique as human beings. The changes of the past decades require communicators and creatives to produce more messages in less and less time. This is where human ability reaches its limits: the process of how content is created today is not made for these developments. That's why we have designed content creation around a new original way of creating content, which we call The ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner Philosophy"
                    }),
                    ". Our motivations are revealed in the following manifesto."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Content creation becomes more tedious."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The creation of content was long considered a manageable challenge. Meanwhile, it has become a Sisyphean task for creative people: expensive, micro-managing, and time-consuming."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The number of communication channels and the demand for different formats are exploding. Creatives must create more variety of content for even more touchpoints. The costs of meeting this demand and audience expectations are rising rapidly as we live in an attention economy."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "It is time to end this Sisyphean task. You deserve technology that helps you become more creative and productive. You deserve a creative space where you and your team can produce compelling stories in the shortest possible time. And you deserve a company and a product whose interests align with yours."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "That's us, that's ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    "."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.h2, {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                        children: "Creating stories"
                    }),
                    " Micromanagement"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Modern content creation software focuses on content management. It either solves a single task or is packed with features but thin on philosophy. Everyone is left to his own devices without guiding principles. Most people do not know how to create content better, and existing software does not help them."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "What is missing is a new approach that has been developed from a different perspective: a completely new philosophy of content creation. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " has it. With a novel design, integrated workflows, and a clear vision, ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " helps you master content creation."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Use ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " and follow the ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner Philosophy"
                    }),
                    ", and you are guaranteed to improve. Few things are as satisfying as finally becoming good at something you have been struggling with for so long."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "We help you to improve."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Tools, tools, tools"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "To this day, the creation of content begins on a blank sheet of paper. A blank canvas with a ticking cursor. No help for what to write or for assessing the quality. Oh yeah, there is a tool for content analysis and notes and your social media content and formatting and images and for exchanging feedback and ... Complexity and inefficiency!"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Software is born from a problem or is based on new technology. We know both sides. Existing software either solves a small task or tries to cover the whole production and publishing process. The creative part is ignored or treated as an island. Existing solutions leave creatives in the lurch and even stand in their way."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Creating content is too fundamental - and too important - to accept the choices we have been given. Someone has to breathe new life into it and bring in new ideas again."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "We have accepted this challenge."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "The Storyliner Philosophy"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "The ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner Philosophy"
                    }),
                    " is essentially based on a technology-enhanced creative process. It works best if you want to plan and develop content and communication strategically. Below you will find a list of guidelines that are important to us. And the premises we reject. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " builds on these basic ideas and principles. While the content industry has overlooked the creative part of content production for years, we have a clear perspective. Here are the pillars we believe in."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#1 Storyline first, channels second"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Storylining is used by all great storytellers or communicators of our time. It is an essential part of storytelling and developing compelling content. The stringing together of information in a logical sequence makes the entire story easy to understand and follow, using only the relevant messages and avoiding unnecessary noise — ideal for corporate communications challenges."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "To create content for different communication channels more efficiently, you first develop a narrative structure and a story's essential messages with ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    ". You will receive inspiration and recommendations based on predefined genres. You can also create your own narrative structures and save the storylines as formats. Then you can transfer the story into your communication channels using technology. In this way, compelling content is created for every touchpoint with your audience."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#2 Part human, part machine"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The changes in the past are one thing above all: technology-driven. More platforms, more devices, an increasing number of content types, and an exponential increase in published content. A lot more than the human imagination. So, why use tools from the last decade to challenge the next?"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "With ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    ", we believe that a machine should support parts of the creative process to promote and enhance our creativity. Machines can better process texts, search for information, edit media, or produce variety. We, humans, are better at putting things into context and creating something new. That's why we develop functions that automate repetitive tasks, optimize workflows, and inspire you as a user in the best possible way."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#3 Capture notes, increase creative output"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Let's face it: most of us fail with productivity or note apps. Often it is because of managing information. We store links, references, or content in different places. When copying back and forth, we don't think about the intended structure and eventually lose track of what's going on. Frustration increases within a team because each of us has a different inner structure and categorizes information differently. We have developed a note system that increases your creative output. You can store information modules, tag them with collections, and reference them within stories. There are no hierarchies. There is no chaos when categorizing and finding your information."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#4 Assemble contents, then refine"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Storylining involves stringing together individual messages, arguments, or scenes to form a narrative structure. We call these Blocks. Thanks to Blocks, you can develop your ideas into a concept and from concept to story. You can format passages, arrange texts, insert pictures and videos, and define the perfect workflow for you and your team. Blocks are used to prepare your storyline for the individual communication channels. So you first compose what you want to communicate, and then you can refine it."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#5 Integrations instead of silos"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "On average, creatives in small to medium-sized companies use five to seven different software tools for content creation. Many of the tools are proprietary and make it difficult to transfer the content. The result is technology discontinuity and inefficiency. On the other hand, we believe in an open Internet and try to integrate ourselves into your existing technology landscape in the best possible way. Be it for your project management, image editing, or exporting content to other platforms and tools. We are the place where you bring your team, your data, and your content together."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#6 Collaboration with a purpose"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "The times of file extensions -final.txt, -final-final-2.docx, etc., are over. With our centralized creation environment and collaboration features, you and your team will become more productive and effective. Highlight the current document status, vote on headlines, content, or images, or work on the same story in parallel. We all know that developing concepts as a team leads to more compelling content. With ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    ", you can put an end to the chaos of collaboration and give your team a sense of purpose."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#7 Privacy and transparency take precedence"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Large technology companies dominate the software market in content creation. We all know their advertising-based business models. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " offers an alternative solution without the obsession of exploiting personal data – we appreciate your transparency and privacy. Therefore, we are not interested in selling your personal data; we only charge a monthly or annual fee for using ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    ". We build great products, and you pay a reasonable price for them. This ensures that we can continue developing our technology and making our business possible without sharing your information. This is fair for everyone."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "The future of content creation"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "We face an exciting future with radical changes: fascinating new technological developments, the increasing demand for compelling content, and the intensification of the attention economy. With ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " and the ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner Philosophy"
                    }),
                    ", we embrace these changes and help shape them. Our goal is to enable, accompany, and support you on this journey."
                ]
            })
        ]
    });
}
function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ }),

/***/ 7310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"storyliner-l9a5zk","storyliner-markdown-button":"storyliner-5WQeFL","storyliner-markdown-image":"storyliner-0CMuRb","responsive-iframe":"storyliner-MQtvxX","iframe-wrapper":"storyliner-s6HK1y","optin-canvas":"storyliner-xzbQ5J","info-text":"storyliner-xynJAU","icon-wrapper":"storyliner-HYoR1F","optin-button":"storyliner-0o3hOL"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"storyliner-ttPbzh"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,6880,5163,9774,2888,179], function() { return __webpack_exec__(4317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);